"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantModal = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var sok_ui_1 = require("@caddigital/sok-ui");
var ParticipantsActions = require("@caddigital/sok-reducers/lib/actions/bid/participants");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var translate_1 = require("utils/translate");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var avatars_1 = require("components/Avatar/avatars");
var components_1 = require("components");
var text_1 = require("utils/text");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var Types = require("types");
// ###################
// ##### LIST ########
// ###################
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        list: state.bid.participants,
        currentUser: state.auth.current.user,
        message: state.bid.message,
        uploadSession: state.bidMessageAttachments.currentUploadStatus.session,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (bid) { return dispatch(ParticipantsActions.fetchRequest(bid)); },
    clear: function () { return dispatch(ParticipantsActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var listCssId = 'BidMessageParticipantModalCSS';
var dataKey = '__email';
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('searchString', 'setSearchString', ''), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _this = this;
        this.props.fetch(this.props.currentBid);
        this.props.setItems(this.props.list.list
            .filter(function (x) { return x.user.email.includes(_this.props.searchString); })
            .sort(function (a, b) { return a.user.email.localeCompare(b.user.email); }));
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.list.list !== prevProps.list.list ||
            this.props.searchString !== prevProps.searchString) {
            this.props.setItems(this.props.list.list
                .filter(function (x) { return x.user.email.includes(_this.props.searchString); })
                .sort(function (a, b) { return a.user.email.localeCompare(b.user.email); }));
        }
        if (this.props.items !== prevProps.items) {
            var contentWidth_1 = 0;
            var columns_1 = {};
            var text = (0, translation_1.getLocalization)("bid/message/participantList/participant");
            columns_1[dataKey] = (0, text_1.calculateStringLength)(text);
            this.props.list.list.forEach(function (item) {
                var emailLength = (0, text_1.calculateStringLength)(item.user.email);
                var prevValue = columns_1[dataKey] || 0;
                if (!prevProps || prevValue < emailLength) {
                    columns_1[dataKey] = emailLength;
                }
            });
            // Override styles for dynamic classes
            var style = document.getElementById(listCssId);
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = listCssId;
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 1 * 40;
            Object.keys(columns_1).forEach(function (className, i) {
                var col = columns_1[className];
                if (col === undefined)
                    return;
                var colwidth = Math.max(8, 4 + col + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var createRowData = function (style, items, selected, setSelected) { return ({
    style: style,
    items: items,
    selected: selected,
    setSelected: setSelected
}); };
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-participants', className: 'no-participants' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("bid/participantView/emptyList/title")))); };
var ListHeader = function (props) {
    var setSelected = props.setSelected, items = props.items, selected = props.selected;
    var isAllSelected = selected.length === items.length && selected.length !== 0;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', className: isAllSelected ? 'selected' : '', circle: true, onClick: function () { return (isAllSelected ? setSelected([]) : setSelected(items)); } })),
        React.createElement("div", { className: 'row__column dynamic briefcase-list-row-column __email' },
            React.createElement("div", { onClick: function () {
                    if (props.items.length === props.selected.length) {
                        props.setSelected([]);
                    }
                    else {
                        props.setSelected(props.items);
                    }
                } }, (0, translation_1.getLocalization)("bid/message/participantList/participant"))),
        React.createElement("div", { className: "row__column narrow" })));
};
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, selected = data.selected, setSelected = data.setSelected;
    var row = items[index];
    var isSelected = selected.find(function (_a) {
        var user = _a.user;
        return user.id === row.user.id;
    });
    return (React.createElement("div", { className: 'row', style: style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { circle: true, className: isSelected && 'selected', icon: 'fa-check', onClick: function () {
                    if (isSelected) {
                        setSelected(selected.filter(function (_a) {
                            var user = _a.user;
                            return user.id !== row.user.id;
                        }));
                    }
                    else {
                        setSelected(__spreadArray(__spreadArray([], selected, true), [row], false));
                    }
                } })),
        React.createElement("div", { className: 'row__column dynamic mobile __email' }, row.user.email),
        React.createElement("div", { className: "row__column narrow" })));
}, function (prev, next) {
    return !(0, List_1.shallowDiffers)(prev, next) && prev.data.selected === next.data.selected;
});
var ParticipantList = enhance(function (props) {
    var itemData = createRowData({}, props.items, props.selected, props.setSelected);
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.TextInput, { value: props.searchString, onChange: function (e) { return props.setSearchString(e.target.value); }, className: 'search', placeholder: (0, translation_1.getLocalization)('bid/message/search/placeholder'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () { return props.setSearchString(''); } }) }),
        React.createElement("div", { className: 'bid-message-view-participant-list-container' },
            React.createElement("div", { className: 'sok-list-content bid-message-view-participant-list' },
                props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(props.currentBid); } }))),
                (props.list.status === 'FETCHING' ||
                    props.list.status === 'STANDBY') && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.list.status === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(ListHeader, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
                }))))));
});
var modalEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('selected', 'setSelected', []), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.participantModal !== prevProps.participantModal) {
            this.props.setSelected([]);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.participantModal || nextProps.participantModal) {
            return true;
        }
        else {
            return false;
        }
    }
}), recompose_1.pure);
exports.ParticipantModal = modalEnhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.participantModal, className: 'bid-message-participants-modal' },
    React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleParticipantModal(false); } }, (0, translation_1.getLocalization)('bid/message/select/participants')),
    React.createElement(sok_ui_1.Container, null, props.participantModal && (React.createElement(ParticipantList, { currentBid: props.currentBid, participantModal: props.participantModal, selected: props.selected, setSelected: props.setSelected }))),
    React.createElement(sok_ui_1.Footer, null,
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', disabled: props.selected.length === 0, text: (0, translation_1.getLocalization)('userfront/button/add'), onClick: function () {
                props.onChange(props.selected);
                props.toggleParticipantModal(false);
            } }),
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel'), onClick: function () { return props.toggleParticipantModal(false); } })))); });
